export default "__VITE_ASSET__CTk0zKfG__"